export const MASK_BRL = 'R$'
export const MASK_USD = 'US$'
